import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { LoanDtoBrief } from 'src/generated-api-client';
import { LoanListItem } from 'src/pages/LoansPage/LoanListItem';
import { LoansHeaderPanel } from 'src/pages/LoansPage/LoansHeaderPanel';
import { LoansStore } from 'src/stores/LoansStore/LoansStore';

export const LoansPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="loans"
            store={store}
            asidePanel={<LoansAsidePanel />}
            data-testid="loans-page"
        >
            <EntityPresentation store={store} entityName="loan" />
        </MasterDetailsPage>
    );
});

const LoansAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: LoanDtoBrief) => {
                return (
                    <List.Item
                        key={item.id}
                        data-testid={`master-details-list-item-${item.id}`}
                    >
                        <LoanListItem item={item} />
                    </List.Item>
                );
            }}
            header={<LoansHeaderPanel />}
        />
    );
});

const store = LoansStore;
